import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AdvancedLookupComponent } from '../../models/lookup';
import { YesNoPipe } from '../../pipes/yesNo.pipe';
import { AdministrarService } from '../../services/administrar.service';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellUserStatisticsComponent } from '../cell-user-statistics/cell-user-statistics.component';

@Component({
  selector: 'app-administracion',
  templateUrl: './administracion.component.html',
  styleUrls: ['./administracion.component.css']
})
export class AdministracionComponent implements OnInit, AdvancedLookupComponent {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;
  public rowData: any;

  createColumnDef() {

    const columnDefs = [
      {
        headerName: this._translateService.instant('administracion.ag_editar'), field: 'authID', suppressFilter: true,
        suppressSorting: true, cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: '/administracion/edit/', hyperlinkText: 'Editar' },
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      { headerName: this._translateService.instant('administracion.ag_status'), field: 'isActive', minWidth: 15, valueFormatter: (data) => this._booleanTransform.transform(data.value) },
      { headerName: this._translateService.instant('administracion.ag_userName'), field: 'userName', minWidth: 230 },
      { headerName: this._translateService.instant('administracion.ag_displayName'), field: 'displayName', minWidth: 150 },
      { headerName: this._translateService.instant('administracion.ag_fullName'), field: 'fullName', minWidth: 150 },
      { headerName: this._translateService.instant('administracion.ag_email'), field: 'email', minWidth: 150 },
      { headerName: this._translateService.instant('administracion.ag_telefono'), field: 'phoneNumber', minWidth: 150 },
      {
        headerName: 'Accesos mes pasado', field: 'authID', minWidth: 40, cellRendererFramework: CellUserStatisticsComponent,
        cellRendererParams: { tipoLog: 2 }
      },
      {
        headerName: 'Accesos mes actual', field: 'authID', minWidth: 40, cellRendererFramework: CellUserStatisticsComponent,
        cellRendererParams: { tipoLog: 1 }
      },
      {
        headerName: 'Accesos hoy', field: 'authID', minWidth: 40, cellRendererFramework: CellUserStatisticsComponent,
        cellRendererParams: { tipoLog: 0 }
      }

    ];
    return columnDefs;
  }

  constructor(private _AdministrarService: AdministrarService, private _router: Router, private _route: ActivatedRoute,
    public _translateService: TranslateService, private _booleanTransform: YesNoPipe) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
  }

  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      console.log(rowid);
      return rowid;

    } else {
      return null;
    }

  }

  ngOnInit() {
    this.getUsuarios();
  }

  public getUsuarios() {
    this._AdministrarService.getUsers().subscribe(data => this.rowData = data,
      (err: any) => {
        console.error('Error, no se ha podido recuperar datos.');
        console.error(err);
      } //,
      //()=>{console.log(this.rowData)}     
    );

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

}
